export default function hexToRgbA(hex: string, alpha: number): string {
	if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
		let chars = hex.substring(1).split('');
		if (chars.length === 3) {
			chars = [chars[0]!, chars[0]!, chars[1]!, chars[1]!, chars[2]!, chars[2]!];
		}
		const c = parseInt('0x' + chars.join(''), 16);
		return `rgba(${(c >> 16) & 255},${(c >> 8) & 255},${c & 255},${alpha})`;
	}
	return `rgba(0,0,0,${alpha})`;
}
